module.exports = __webpack_public_path__ + "8a5356e9/img/settings-icon.121d9519.svg";